import { CellInfo } from "../../types/CellInfo";
import { AppAction, JupyterState, JupyterStatus } from "../types";

/** All the jupyter action types. */
export enum JupyterActionKey {
  SET_JUPYTER_STATE = "SET_JUPYTER_STATE",
  SET_JUPYTER_STATUS = "SET_JUPYTER_STATUS",
  SET_CELL_STATE = "SET_CELL_STATE",
}

export type JupyterEventRequest = any;

/** An action that sets the jupyter state collectively. */
export interface SetJupyterStateAction
  extends AppAction<
    JupyterActionKey.SET_JUPYTER_STATE,
    { jupyter: JupyterState }
  > {}

/** An action that sets the jupyter status to initialized. */
export interface SetJupyterStatusAction
  extends AppAction<
    JupyterActionKey.SET_JUPYTER_STATUS,
    { status: JupyterStatus }
  > {}

/** All the jupyter actions. */
export type JupyterAction = SetJupyterStateAction | SetJupyterStatusAction;

/** Sets the jupyter state. */
export const setJupyterState = (
  jupyter: JupyterState
): SetJupyterStateAction => ({
  type: JupyterActionKey.SET_JUPYTER_STATE,
  payload: { jupyter },
});

/** Sets the jupyter status initialized, it is ready to communicate. */
export const setJupyterStatus = (
  status: JupyterStatus
): SetJupyterStatusAction => ({
  type: JupyterActionKey.SET_JUPYTER_STATUS,
  payload: { status },
});

/** An action that updates the CellInfo state. */
export interface SetCellStateAction
  extends AppAction<JupyterActionKey.SET_CELL_STATE, { state: CellInfo[] }> {}

/** Sets the CellInfo state to the passed value. */
export const setCellState = (state: CellInfo[]): SetCellStateAction => ({
  type: JupyterActionKey.SET_CELL_STATE,
  payload: { state },
});
